<template>
  <div class="modal fade" :id="modalDialogid" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button
            type="button"
            class="btn close"
            data-bs-dismiss="modal"
            :aria-label="$texter.stang"
          >
            <Icon :type="'cross'"></Icon>
          </button>
        </div>

        <div class="modal-body text-center">
          {{ $texter.verifieraTaBort }}
        </div>

        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn btn-primary"
            data-bs-dismiss="modal"
            @click="removeComment()"
          >
            {{ $texter.taBortModal }}
          </button>
          
          <button type="button" class="btn btn-default btn-cancel" data-bs-dismiss="modal">
            {{ $texter.avbryt }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from "../../image/icon.vue";

export default {
  name: "CommentRemove",
  props: {
    commentId: Number,
  },
  data: function () {
    return {
      isLoading: false,
    };
  },
  components: {
    Icon,
  },
  computed: {
    modalDialogid: function () {
      return "commentRemoveModal-" + this.commentId;
    },
  },
  methods: {
    removeComment() {
      this.$commentService
        .removeComment(
          this.commentId,
          this.$isAdmin,
        )
        .then((res) => {
          this.$fetchData();
        });
    },
  },
};
</script>
